import { getModel } from '../../model/registry'
import { useEffect } from 'react'
import styled from 'styled-components'
import { useSnapshot } from 'valtio'

import useTranslation from '../../hooks/useTranslation'
import { useStore } from '../pageView/Page'
import { icon } from '../../styles/icons'

import LineDocuments from './LineDocuments'
import { documentLine } from './documentLineState'

/*
 * The side panel's view of a line's documents: whichever line the grid's
 * cursor, a line's documents button or an opened line last pointed at — the
 * first line until then. Another record forgets the line, so it does not open
 * on a line it may not have; folding the panel away and back does not.
 */
const LineDocumentsPanel = ({ meta = {}, entity }) => {
  const shown = useSnapshot(documentLine)
  const [recordId] = useStore(s => s?.id)

  useEffect(() => {
    if (documentLine.recordId !== recordId) {
      documentLine.recordId = recordId
      documentLine.index = null
    }
  }, [recordId])

  return <LineDocuments lineDocuments={meta.lineDocuments} index={shown.index ?? 0} entity={entity} />
}

const Count = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  color: ${({ theme, $some }) => $some ? theme.tab.navLinkColor : theme.font.label};
  font-size: var(--font-XS);
  font-weight: 600;

  svg { font-size: 1.25rem; }
`

/*
 * The folded panel's counter: how many documents the line in hand has
 * (deleted ones not counted), so a closed panel still says there is
 * something to see.
 */
export const LineDocumentsCount = ({ meta = {} }) => {
  const config = getModel('lineDocumentsData')[meta.lineDocuments] ?? {}
  const shown = useSnapshot(documentLine)
  const index = shown.index ?? 0
  const [attachments] = useStore(s => s?.[config.linesArray ?? 'lines']?.[index]?.attachments)
  const { m } = useTranslation()

  const count = Array.isArray(attachments) ? attachments.filter(a => !a.deletedAt).length : 0

  return (
    <Count $some={count > 0} title={m('document.lines.count', [index + 1, count])}>
      {icon.attachment}
      <span>{count}</span>
    </Count>
  )
}

export default LineDocumentsPanel
